import React from "react";
import { Modal, Button, Box } from "@mui/material";
import { H5 } from "./Typography";
import { load } from "../constants/storage";

import { MuiOtpInput } from "mui-one-time-password-input";

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: (value: any) => void;
};

function OTPModel({ open, handleClose, handleSave }: MyModalProps) {
  let userDetail: any = load("userData");
  let userDetails = JSON.parse(userDetail);
  const handleChange = (newValue: any) => {
    setOtp(newValue);
  };
  const [otp, setOtp] = React.useState("");
  const handleSaveClick = () => {
    handleSave(otp);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            Enter OTP
          </H5>
        </Box>
        <Box sx={container}>
          <H5
            fontWeight={400}
            sx={{ color: "#595959", fontFamily: "'Poppins', sans-serif" }}
          >
            Sent to your registered mobile No.
          </H5>
          <H5
            fontWeight={400}
            sx={{
              mt: 1,
              mb: 2,
              color: "#595959",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            +91-{userDetails.mobile}
          </H5>
          <Box
            sx={{
              width: "70%",
            }}
          >
            <MuiOtpInput
              sx={styleOtpBox}
              value={otp}
              autoFocus
              onChange={handleChange}
            />
          </Box>
          <Box sx={buttonContainer}>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Submit
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default OTPModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md: "30%",
    xs: "90%",
  },
  bgcolor: "background.paper",

  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const header = {
  width: "100%",
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,

  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "90%",
  justifyContent: "center",
  flexDirection: "row",
  display: "flex",
  p: 1,
  mt: 1.5,
};
const styleOtpBox = {
  display: "flex",
  gap: {
    xs: 1,
    sm: 2,
    md: 1,
  },
  marginInline: "auto",
};
const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "80%",
    xs: "100%",
  },
  mb: 1,
  borderRadius: 2,
};
